import { render, staticRenderFns } from "./KegelQuestionsQuestion.vue?vue&type=template&id=875f31a0&"
import script from "./KegelQuestionsQuestion.vue?vue&type=script&lang=js&"
export * from "./KegelQuestionsQuestion.vue?vue&type=script&lang=js&"
import style0 from "./KegelQuestionsQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports